import TableCellSpace from "ds/components/Table/Row/CellSpace";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { IntegrationsAzureUsedByTableCellProps } from "./types";

const IntegrationsAzureUsedByTableSpaceCell = ({
  item: stack,
  ...cellProps
}: IntegrationsAzureUsedByTableCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellSpace href={`/spaces/${stack.spaceDetails.id}`}>
        {stack.spaceDetails.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default IntegrationsAzureUsedByTableSpaceCell;
